/**
 * Customer Main Type Constants
 * Source: login_types table (unique_id column)
 * Used for customer network hierarchy (Primary -> Secondary -> Tertiary -> Influencer)
 *
 * Database login_types:
 * - 100: INFLUENCER
 * - 101: PRIMARY_CUSTOMER
 * - 102: SECONDARY_CUSTOMER
 * - 103: TERTIARY_CUSTOMER
 */

export const CUSTOMER_MAIN_TYPE_ID = {
  INFLUENCER: 100,
  PRIMARY: 101,
  SECONDARY: 102,
  TERTIARY: 103,
} as const;

export const CUSTOMER_MAIN_TYPE_NAMES: Record<number, string> = {
  100: 'Influencer',
  101: 'Primary (Distributor)',
  102: 'Secondary (Retailer)',
  103: 'Tertiary (Sub-Dealer)',
};

export const CUSTOMER_MAIN_TYPE_CODES: Record<number, string> = {
  100: 'INFLUENCER',
  101: 'PRIMARY',
  102: 'SECONDARY',
  103: 'TERTIARY',
};

export const CUSTOMER_MAIN_TYPE_COLORS: Record<number, string> = {
  100: 'warning',
  101: 'primary',
  102: 'success',
  103: 'info',
};

// Type for Customer Main Type ID values
export type CustomerMainTypeIdValue = typeof CUSTOMER_MAIN_TYPE_ID[keyof typeof CUSTOMER_MAIN_TYPE_ID];
